import {useController} from 'react-hook-form';
import {type PropsWithChildren} from 'react';
import styles from './error-message.module.css';
import {
  type FormFieldPath,
  useCompanyRegistrationFormContext,
} from '@/features/company-registration/form';

/**
 * 指定した name のフィールドに対するエラーメッセージを ErrorMessage で表示する
 */
export function FormErrorMessage({name}: {readonly name: FormFieldPath}) {
  const {control} = useCompanyRegistrationFormContext();
  const {
    fieldState: {error},
  } = useController({control, name});

  if (error?.message === undefined) return null;

  return (
    <p id={`${name}-error`} className={styles.error}>
      {error.message}
    </p>
  );
}

/**
 * エラーメッセージを表示する
 */
export function ErrorMessage({
  id,
  children,
}: PropsWithChildren<{
  readonly id?: string;
}>) {
  return (
    <p id={id} className={styles.error}>
      {children}
    </p>
  );
}
